import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router } from '@angular/router';
import { CredentialComponent } from '../../dialogs/credential/credential.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { FormGroup } from '@angular/forms';
import {CssService} from "../../../services/css-service";

@Component({
  selector: 'app-credentials',
  templateUrl: './credentials.component.html',
  styleUrls: ['./credentials.component.css']
})
export class CredentialsComponent implements OnInit {

  // Email utilisé lors de l'inscription | connexion
  @Input()
  currEmail: any;

  // Nom de la page ou rediriger après connexion ou inscription
  @Input()
  redirectPage: string|any;

  // Formulaire de création de compte
  @Input()
  registerForm: FormGroup|any;

  /**
   * Set les informations récoltées via credential de l'utilisateur dans le formulaire
   */
  @Output() setUserInfoInputsEvent = new EventEmitter<any>();

  constructor(
    private authService: AuthService,
    private dialog: MatDialog,
    public cssService: CssService,
    private tools: ToolsService
  ) { }

  ngOnInit() { }

  /**
   * @description Login ou register via facebook | google | twitter
   * @param {string} credentialName
   * @return {void}
   */
  signInCredential(credentialName: string): void {


    const that = this;

    // Données nécessaire lors de l'inscription
    let lastname: string|any;
    let firstname: string|any;
    let countryId: number|any;
    let phone: string|any;

    // Si il y a formulaire renseigné alors on increment les variables avec les données du formulaire
    if (this.registerForm) {
      lastname = this.registerForm.get("lastname").value
      firstname = this.registerForm.get("firstname").value
      countryId = this.registerForm.get("id_country").value
      phone = this.registerForm.get("phone").value
    }

    // Voir description fonction
    that.authService.signInWithCredential(credentialName, phone, countryId, firstname, lastname).then((data) => {


      // Redirection
      that.tools.goRedirectPage(that.redirectPage);

    }).catch(function (err) {


      // Si erreur de credential on ouvre la popup qui correspond
      if (err.error === "credential") {

        that.openCrendentialDial();

        // Si erreur email déjà utilisé on set l'email récupéré dans la réponse pour pouvoir l'afficher dans le message d'erreur
      } else if (err.error === "credentialinfomissing") {

        that.setUserInfoInputsEvent.emit(err.user_info);


      } else if (err.email) {

        that.currEmail = err.email;

      }

    });

  }

  /**
   * @description Ouvre la popup d'erreur de connexion avec credential
   * @return {void}
   */
  openCrendentialDial(): void {
    const that = this;
    const dialConf = new MatDialogConfig();
    dialConf.data = { registerForm: this.registerForm }
    dialConf.width = "350px";
    const myDial = that.dialog.open(CredentialComponent, dialConf);

    myDial.afterClosed().subscribe(function (result) {
      if (result) {
        that.tools.goRedirectPage(that.redirectPage);
      }
    });
  }

}
